import moment from "moment/moment";
import {serializer} from "@/api/shared/serializer";
import firebase from "firebase";
import {EventsTypes} from "@/enums/EventsTypes";
import Loader from "@/components/loader/Loader.vue";
import {upload} from "vue-grapesjs";
import { GalleryStockPhotosMixin } from "@/mixins/GalleryStockPhotos";

export default {
  name: "GalleryPhotosUploadDlg",
  mixins: [GalleryStockPhotosMixin],
  data() {
    return {
      dialog: false,
      loading: true,
      startDateCameraRoll: moment().subtract(1, 'month').toISOString().substring(0, 10),
      endDateCameraRoll: moment().toISOString().substring(0, 10),
      startDateEventPictures: moment().subtract(1, 'month').toISOString().substring(0, 10),
      endDateEventPictures: moment().toISOString().substring(0, 10),
      startDateStockPhotos: moment().subtract(1, 'month').toISOString().substring(0, 10),
      endDateStockPhotos: moment().toISOString().substring(0, 10),
      lastCameraRollPhoto: '',
      lastEventPicturesPhoto: '',
      lastStockPicturesPhoto: '',
      selectedFolder: null,
      pickerCameraRoll: {
        start: false,
        end: false,
      },
      pickerCEventPictures: {
        start: false,
        end: false,
      },
      pickerStockPhoto: {
        start: false,
        end: false,
      },
      selectedCameraRollPhoto: {
        image: "",
        thumbnailUrl: "",
      },
      selectedEventPicturesPhoto: {
        image: "",
        thumbnailUrl: "",
      },
      selectedGalleryFolderPhoto: {
        image: "",
        thumbnailUrl: "",
      },
      selectedStockPhoto: {
        image: "",
        thumbnailUrl: "",
      },
      events: [],
      selectedEvent: null,
      stockPhotos: []
    }
  },
  components: {
    Loader
  },
  computed: {
    facility(){
      return this.$store.state.facilityModule.selectedFacility;
    },
    formattedStartDateCameraRoll() {
      return moment(this.startDateCameraRoll).format(this.facility.dateFormat);
    },
    formattedEndDateCameraRoll() {
      return moment(this.endDateCameraRoll).format(this.facility.dateFormat);
    },
    formattedStartDateEventPictures() {
      return moment(this.startDateEventPictures).format(this.facility.dateFormat);
    },
    formattedEndDateEventPictures() {
      return moment(this.endDateEventPictures).format(this.facility.dateFormat);
    },
    formattedStartDateStockPhotos() {
      return moment(this.startDateStockPhotos).format(this.facility.dateFormat);
    },
    formattedEndDateStockPhotos() {
      return moment(this.endDateStockPhotos).format(this.facility.dateFormat);
    },
    photos() {
      const photos = this.$store.state.galleryModule.photos.filter(x => x.image);
      return serializer.transformFields(photos, {
          src: image => image,
          description: () =>
            'Star Night Sky Ravine by Mark Basarab, from Unsplash.',
          thumbnailWidth: () => '220px',
          alt: alt => 'no image',
        });
    },
    isCameraRoll() {
      return this.selectedFolder === this.$t("Gallery.CameraRoll");
    },
    isEventPictures() {
      return this.selectedFolder === this.$t("Gallery.EventPictures");
    },
    isGalleryFolder() {
      return this.galleryFolders.find(x => x.id === this.selectedFolder);
    },
    isStockPhotos() {
      return this.selectedFolder === this.$t("Gallery.StockPhotos");
    },
    isSelectedCameraRollPhoto() {
      return this.selectedCameraRollPhoto.image?.length;
    },
    isSelectedStockPhoto() {
      return this.selectedStockPhoto.image?.length;
    },
    galleryFolders() {
      return this.$store.state.galleryModule.galleryFolders;
    },
    galleryFolderPhotos() {
      return this.$store.state.galleryModule.galleryFolderPhotos;
    }
  },
  async created() {
    Promise.all([
      await this.getLastPhotoFromGallery(),
      await this.getLastPhotoFromEvents(),
      await this.getLastPhotoFromStock(),
      await this.$store.dispatch("getGalleryFolders")
    ]).then(() => {
      this.loading = false;
    })
  },
  methods: {
    upload() {
      return upload
    },
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    getPhotosCameraRoll() {
      this.$store.dispatch('getFacilityPhotos', {
        startDate: moment(this.startDateCameraRoll).toDate(),
        endDate: moment(this.endDateCameraRoll).toDate(),
      });
    },
    selectFolder(value: string) {
      this.selectedFolder = value;

      if(this.isCameraRoll) {
        this.getPhotosCameraRoll();
        return;
      }

      if(this.isEventPictures) {
        this.getGalleryEventPictures();
        return;
      }

      if(this.isStockPhotos) {
        this.getFavouritePhotos();
        return;
      }

      if(this.isGalleryFolder) {
        this.$store.dispatch("getGalleryFolderPhotos", this.selectedFolder)
        return;
      }
    },
    uploadPhotoToEvent(type) {
      if(type === this.$t('Gallery.CameraRoll') && this.isCameraRoll) {
        this.selectedEventPicturesPhoto.image = "";
        this.selectedEventPicturesPhoto.thumbnailUrl = "";

        this.selectedGalleryFolderPhoto.image = "";
        this.selectedGalleryFolderPhoto.thumbnailUrl = "";

        this.selectedStockPhoto.image = "";
        this.selectedStockPhoto.thumbnailUrl = "";

        this.$emit('uploadGalleryPhoto', this.selectedCameraRollPhoto);
      }

      if(type === this.$t('Gallery.EventPictures') && this.isEventPictures) {
        this.selectedCameraRollPhoto.image = "";
        this.selectedCameraRollPhoto.thumbnailUrl = "";

        this.selectedGalleryFolderPhoto.image = "";
        this.selectedGalleryFolderPhoto.thumbnailUrl = "";

        this.selectedStockPhoto.image = "";
        this.selectedStockPhoto.thumbnailUrl = "";

        this.$emit('uploadGalleryPhoto', this.selectedEventPicturesPhoto);
      }

      if(type === "Gallery Folder" && this.isGalleryFolder) {
        this.selectedCameraRollPhoto.image = "";
        this.selectedCameraRollPhoto.thumbnailUrl = "";

        this.selectedEventPicturesPhoto.image = "";
        this.selectedEventPicturesPhoto.thumbnailUrl = "";

        this.selectedStockPhoto.image = "";
        this.selectedStockPhoto.thumbnailUrl = "";

        this.$emit('uploadGalleryPhoto', this.selectedGalleryFolderPhoto);
      }

      if(type === this.$t('Gallery.StockPhotos') && this.isStockPhotos) {
        this.selectedCameraRollPhoto.image = "";
        this.selectedCameraRollPhoto.thumbnailUrl = "";

        this.selectedEventPicturesPhoto.image = "";
        this.selectedEventPicturesPhoto.thumbnailUrl = "";

        this.selectedGalleryFolderPhoto.image = "";
        this.selectedGalleryFolderPhoto.thumbnailUrl = "";

        this.$emit('uploadGalleryPhoto', this.selectedStockPhoto);
      }

      this.close();
    },
    async getLastPhotoFromGallery() {
      const fromDate = moment().subtract(1, "month").startOf('day').unix() * 1000;
      const toDate = moment().endOf("day").unix() * 1000;

      await firebase
        .firestore()
        .collection("photos")
        .where("facilityId", "==", this.$store.state.authModule.currentFacility)
        .where('isStaff', '==', true)
        .where('createdAt', '>=',  fromDate)
        .where('createdAt','<=',  toDate)
        .orderBy("createdAt", "desc")
        .get()
        .then((querySnapshot) => {
          const photos: any = serializer.querySnapshotToDocuments(querySnapshot)
            .filter((x: any) => !x.folderId)
            .filter((x: any) => x.isStaff)
            .filter((x: any) => !x.isStock)
            .filter((x: any) => x.image);

          this.lastCameraRollPhoto = photos[0]?.image ? photos[0]?.image : require("../../../../assets/no-image.jpg");
        })
    },
    async getLastPhotoFromEvents() {
      const fromDate = moment().subtract(1, "month").startOf('day').toDate();
      const toDate = moment().endOf("day").toDate();

      await firebase
        .firestore()
        .collection("calender")
        .where("facilityId", "==", this.$store.state.authModule.currentFacility)
        .where("start", ">", fromDate)
        .where("start", "<", toDate)
        .where("type", "in", [EventsTypes.ConciergeRequest, EventsTypes.Concierge, EventsTypes.PremiumServices, EventsTypes.LifestylePrograms])
        .get()
        .then((querySnapshot) => {
          let photos: any = serializer.querySnapshotToDocuments(querySnapshot);

          photos = photos.filter((x: any) => {
            if(x?.galleryPhotos && x?.galleryPhotos.length >= 1) {
              return x;
            }
          });

          photos = photos.sort((a: any, b: any) => moment(b.start.seconds * 1000).diff(moment(a.start.seconds * 1000)));

          this.lastEventPicturesPhoto = photos[0]?.galleryPhotos[0]?.photoUrl ? photos[0]?.galleryPhotos[0]?.photoUrl : require("../../../../assets/no-image.jpg");
        })
    },
    async getLastPhotoFromStock() {
      const fromDate = moment().subtract(1, "month").startOf('day').unix() * 1000;
      const toDate = moment().endOf("day").unix() * 1000;

      await firebase
        .firestore()
        .collection("photos")
        .where("facilityId", "==", this.$store.state.authModule.currentFacility)
        .where("isStock", "==", true)
        .where('createdAt', '>=',  fromDate)
        .where('createdAt','<=',  toDate)
        .orderBy("createdAt", "desc")
        .get()
        .then((data) => {
          const photos: any = serializer.querySnapshotToDocuments(data).sort((a: any, b: any) => moment(b.createdAt).diff(moment(a.createdAt)));
          this.lastStockPicturesPhoto = photos[0]?.image ? photos[0]?.image : require("../../../../assets/no-image.jpg");
        })
    },
    async getGalleryEventPictures() {
      const fromDate = moment(this.startDateEventPictures).startOf('day').toDate()
      const toDate = moment(this.endDateEventPictures).endOf("day").toDate()

      await firebase
        .firestore()
        .collection("calender")
        .where("facilityId", "==", this.facility.id)
        .where("isPublished", "==", true)
        .where("start", ">=", fromDate)
        .where("start", "<=", toDate)
        .where("type", "in", [EventsTypes.ConciergeRequest, EventsTypes.Concierge, EventsTypes.PremiumServices, EventsTypes.LifestylePrograms])
        .get()
        .then((querySnapshot) => {
          let events = serializer.querySnapshotToDocuments(querySnapshot);

          events = events.filter((x: any) => {
            if(x?.galleryPhotos && x?.galleryPhotos.length >= 1) {
              return x;
            }
          });

          events = events.sort((a: any, b: any) => moment(b.start.seconds * 1000).diff(moment(a.start.seconds * 1000)));

          this.events = events.map((x: any) => {
            return {
              id: x.id,
              name: x.name,
              start: moment(x.start.seconds * 1000).format("dddd, DD MMMM, YYYY"),
              galleryPhotos: x.galleryPhotos
            }
          })
        })
    },
    async getFavouritePhotos() {
      const fromDate = moment(this.startDateStockPhotos).startOf('day').unix() * 1000;
      const toDate = moment(this.endDateStockPhotos).endOf("day").unix() * 1000;

      await firebase
        .firestore()
        .collection("photos")
        .where("facilityId", "==", this.facility.id)
        .where("isStock", "==", true)
        .where('createdAt', '>=', fromDate)
        .where('createdAt','<=', toDate)
        .orderBy("createdAt", "desc")
        .get()
        .then((data) => {
          this.stockPhotos = serializer.querySnapshotToDocuments(data).sort((a: any, b: any) => moment(b.createdAt).diff(moment(a.createdAt)));
        })
    },
    openEvent(id: string) {
      this.selectedEvent = this.events.find(x => x.id === id);
    },
    backToFolder() {
      this.selectedFolder = null;
    }
  }
}